import React from 'react';
import DataList from './DataList';
import { useAuth } from '../hooks/useAuth';

const UserManagement = () => {
  const { hasPermission } = useAuth();
  const apiConfig = {
    title: 'User Management',
    path: '/user-management',
    fetchEndpoint: '/hospital-portal/api/users',
    createEndpoint: '/hospital-portal/api/users',
    updateEndpoint: '/hospital-portal/api/users',
    deleteEndpoint: '/hospital-portal/api/users',
    defaultSortFieldId: 'name',
    allowAdd: true,
    bulkActions: [], // Add bulk actions if required
    allowExport: hasPermission('/user-management', 'Export'),
    dropdownFields: [
      {
        name: 'role',
        endpoint: '/hospital-portal/api/roles',
        valueField: 'name',
        labelField: 'name',
      },
    ],
    staticDropdownFields: [
      {
        name: 'device_access_scope',
        options: [
          { id: 'desktop_tablet_only', name: 'Desktop & Tablet Only' },
          { id: 'allow_mobile', name: 'Allow Mobile' },
        ],
      },
      {
        name: 'network_access_scope',
        options: [
          { id: 'hospital_only', name: 'Hospital Only' },
          { id: 'remote_allowed', name: 'Remote Allowed' },
        ],
      },
    ],
    fields: [
      {
        name: 'id',
        label: 'ID',
        type: 'text',
        disabled: true,
        identifier:true,
        tab: 'Main',
      },
      {
        name: 'firebase_uid',
        label: 'Firebase UID',
        required: true,
        type: 'text',
        tab: 'Main',
      },
      {
        name: 'name',
        label: 'Name',
        type: 'text',
        required: true,
        tab: 'Main',
      },
      {
        name: 'email',
        label: 'Email',
        type: 'email',
        required: true,
        tab: 'Main',
      },
      {
        name: 'role',
        label: 'Role',
        type: 'dropdown',
        required: true,
        tab: 'Main',
      },
      {
        name: 'device_access_scope',
        label: 'Device Access Scope',
        type: 'dropdown',
        tab: 'Main',
      },
      {
        name: 'network_access_scope',
        label: 'Network Access Scope',
        type: 'dropdown',
        tab: 'Main',
      },
      
    ],
    tabs: [
      {
        id: 'Main',
        name: 'Main',
        roles: 'all',
      },
    ],
    allowEdit: true,
  };

  const columns = [
    { name: 'ID', selector: (row) => row.id, sortable: true,identifier:true, width: '50px', },
    { name: 'Name', selector: (row) => row.name, sortable: true,filterable: true,filterSelector: 'name' },
    { name: 'Email', selector: (row) => row.email, sortable: true },
    { name: 'Firebsae ID', selector: (row) => row.firebase_uid,style: {width: 'auto'} },
    { name: 'Role', selector: (row) => row.role, sortable: true,filterable: true,filterSelector: 'role' },
    { name: 'Device Access', selector: (row) => row.device_access_scope, sortable: true,filterable: true,filterSelector: 'device_access_scope' },
    { name: 'Network Access', selector: (row) => row.network_access_scope, sortable: true,filterable: true,filterSelector: 'network_access_scope' },
  ];

  return <DataList apiConfig={apiConfig} columns={columns} />;
};

export default UserManagement;
